import Decimal from 'decimal.js';

export const getAmountWithCentsTo2Decimals = (value: string | number | Decimal) =>
  new Decimal(value).dividedBy(100).toDecimalPlaces(2).toNumber();

export const getAmountMultiplyBy100ToInteger = (value: string | number | Decimal) =>
  new Decimal(value).times(100).toDecimalPlaces(0).toNumber();
